export const environment = {
    production: false,
    apiUrl: 'https://dev-be.maploops.com/api',
    secretKey: 'secretKeyE#$$$ewrwe',
    googleMapsApiKey:'AIzaSyBc7W3Y_wa4RHysIWNAEPjYUkkgoYbKYBY'
};
